import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/api.service";

@Injectable()
export class MultipackCommercialPlanningService {
    constructor(
        private apiService: ApiService,
        private httpClient: HttpClient
    ) { }

    doGetStartupInfos(planningInfosParams: any) {
        return this.httpClient.post<StartupInfos_MultipackCommercialPlanning>(this.apiService.workspaceEndpointUrl + "/api/Multipack/doGetStartupInfosAction_Multipack", planningInfosParams)
            .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }

    doGetPlanningDatasAction(planningDatasRequest: any) {
        return this.httpClient.post<any[]>(this.apiService.workspaceEndpointUrl + "/api/Multipack/doGetPlanningDatasAction_Multipack", planningDatasRequest)
            .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur'))).toPromise();
    }
} 

export class StartupInfos_MultipackCommercialPlanning {
    AGENTS: { AGENT_ID: string, AGENT_FULLNAME }[] = [];
    TIERS: { TIERS_ID: string, TIERS_FULLNAME: string, TIERS_TYPE: number, TIERS_SOLDE: number }[] = [];
    COLUMNS_MAPPING: any[] = [];
    NUM_DS_PLANNING: string;
}


export enum MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS {
    RECOUVREMENT = 'RECOUVREMENT',
    FOURNISSEUR = 'FOURNISSEUR',
    BANQUE = 'BANQUE',
}

export const MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS_LABELS: {[key: string]: string} = {
    'RECOUVREMENT': 'Recouvrement',
    'FOURNISSEUR': 'Fournisseur',
    'BANQUE': 'Banque',
}

export const MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS_OPTIONS: any[] = [
    { mVALUE_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS.RECOUVREMENT, mDISPLAY_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS_LABELS[MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS.RECOUVREMENT] },
    { mVALUE_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS.FOURNISSEUR, mDISPLAY_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS_LABELS[MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS.FOURNISSEUR] },
    { mVALUE_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS.BANQUE, mDISPLAY_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS_LABELS[MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS.BANQUE] },
];

export enum MULTIPACK_COMMERCIAL_PLANNING_PRIORITES {
    NORMAL = 'NORMAL',
    URGENT = 'URGENT',
    TRES_URGENT = 'TRES_URGENT',
}

export const MULTIPACK_COMMERCIAL_PLANNING_PRIORITES_LABELS: {[key: string]: string} = {
    'NORMAL': 'Normal',
    'URGENT': 'Urgent',
    'TRES_URGENT': 'Très urgent',
}

export const MULTIPACK_COMMERCIAL_PLANNING_PRIORITES_OPTIONS: any[] = [
    { mVALUE_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_PRIORITES.NORMAL, mDISPLAY_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_PRIORITES_LABELS[MULTIPACK_COMMERCIAL_PLANNING_PRIORITES.NORMAL] },
    { mVALUE_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_PRIORITES.URGENT, mDISPLAY_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_PRIORITES_LABELS[MULTIPACK_COMMERCIAL_PLANNING_PRIORITES.URGENT] },
    { mVALUE_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_PRIORITES.TRES_URGENT, mDISPLAY_MEMBER: MULTIPACK_COMMERCIAL_PLANNING_PRIORITES_LABELS[MULTIPACK_COMMERCIAL_PLANNING_PRIORITES.TRES_URGENT] },
];